import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  background: ${colors.background};
  flex-direction: row;

  border-radius: 12px;
  padding: 24px;
  margin: 24px 0;
`

export const Content = styled.div`
  width: 100%;
  height: 135px;
`

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  margin-right: 8px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.strongGray};
`

export const DropContainer = styled.div`
  display: flex;
  min-height: 60%;
  background: ${colors.background};

  padding: 24px;
  margin: 24px;
  border-radius: 12px;
`
